export const BOT_DIFFICULTY_IDS = ['easy', 'medium', 'hard'] as const;

export type BotDifficultyId = (typeof BOT_DIFFICULTY_IDS)[number];

/** Public bot games always use strongest play. */
export const DEFAULT_BOT_DIFFICULTY: BotDifficultyId = 'hard';

export type BotDifficultyConfig = {
  id: BotDifficultyId;
  label: string;
  /** Short player-facing blurb (no sampling jargon). */
  description: string;
  /** Softmax temperature — higher = more random. Ignored when greedy. */
  temperature: number;
  /** Nucleus sampling mass. Ignored when greedy. */
  topP: number;
  /** Always pick the highest-logit legal action. */
  greedy: boolean;
};

export const BOT_DIFFICULTIES: Record<BotDifficultyId, BotDifficultyConfig> = {
  easy: {
    id: 'easy',
    label: 'Easy',
    description: 'Forgiving — Blind Bot makes mistakes.',
    temperature: 1.8,
    topP: 0.95,
    greedy: false,
  },
  medium: {
    id: 'medium',
    label: 'Medium',
    description: 'A solid challenge with some variety.',
    temperature: 0.85,
    topP: 0.8,
    greedy: false,
  },
  hard: {
    id: 'hard',
    label: 'Hard',
    description: 'Always plays its strongest move.',
    temperature: 0.01,
    topP: 0.01,
    greedy: true,
  },
};

export function resolveBotDifficulty(value: unknown): BotDifficultyConfig {
  const key = String(value ?? DEFAULT_BOT_DIFFICULTY).toLowerCase();
  if (key in BOT_DIFFICULTIES) {
    return BOT_DIFFICULTIES[key as BotDifficultyId];
  }
  return BOT_DIFFICULTIES[DEFAULT_BOT_DIFFICULTY];
}
